import React, { memo } from "react";

import type { INews } from "../../hooks/reactQueryHooks/useNews";
import { useNews } from "../../hooks/reactQueryHooks/useNews";
import { NewsItem } from "./NewsItem";
import { NewsLoader } from "./NewsLoader";

interface INewsContentProps {
  lastVisitTime: number | null;
}

const NewsContent: React.FC<INewsContentProps> = memo(({ lastVisitTime }) => {
  const { isLoading, data } = useNews();

  return (
    <div className="news-content">
      {isLoading && <NewsLoader />}
      {data &&
        data.map((news: INews) => (
          <NewsItem key={news.id} news={news} lastVisitTime={lastVisitTime} />
        ))}
    </div>
  );
});

export { NewsContent };
